const {consumeContext, provideContext} = require("@common/react/context");
const {cs} = require("@common/react/chain-services");

const loadEnvApis = ({next, envId}) =>
    cs(consumeContext("apis"), ["envApis", ({apis}, next) => (envId ? apis.withEnv({envId, next}) : next(null))], ({envApis, apis}) =>
        provideContext("apis", {...apis, ...envApis}, next)
    );
exports.loadEnvApis = loadEnvApis;
